import { removeLocalStorage } from "./storage";

export const reissueError = (accessToken, refreshToken) => {
  window.location.href = process.env.REACT_APP_LOGIN_URL; // 여기서 에러 처리
  removeLocalStorage(accessToken);
  removeLocalStorage(refreshToken);
};
